import { Directive, Host, OnInit, Optional } from '@angular/core';
import { ToggleGroupDirective } from './toggle-group.directive';

@Directive({
  selector: '[rlToggle]'
})
export class ToggleDirective implements OnInit {

  constructor(@Host() @Optional() private groupMng : ToggleGroupDirective) {
    if(groupMng == null) console.error("Missing a ToggleGroupDirective");
  }

  ngOnInit(): void {
    this.groupMng.elements.push(this);
  }

  onOpen() : void {
    console.error("please define ToggleDirective.onOpen");
  }

  onClose() : void {
    console.error("please define ToggleDirective.onClose");
  }

  open(){
    this.groupMng.closeAll();
    this.onOpen();
  }

}
